import { observer } from 'mobx-react-lite'

import { removeFromStack, stack } from './stack'
import { DialogModal } from './DialogModal'

export const DialogStack = observer(() => {
    return stack.map(({ key, Component, dialogProps, onClose }) => (
        <DialogModal
            {...dialogProps}
            key={key}
            onClose={(value) => {
                removeFromStack(key)
                onClose(value)
            }}
            onDestroyDialog={() => {
                removeFromStack(key)
            }}
        >
            <Component />
        </DialogModal>
    ))
})
